import { useMemo, useState } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  useTheme,
  usePermissions,
  FunctionField,
  RecordContextProvider,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import PurchaseNetCardExpandList from "../../components/purchaseNetCards/expand/PurchaseNetCardExpandList";
import PurchaseReturnCardList from "../purchaseReturnCards/PurchaseReturnCardList";
import purchaseNetCardFilterList from "../../components/purchaseNetCards/filter/purchaseNetCardFilterList";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import PurchaseNetCardFooterList from "../../components/purchaseNetCards/footer/PurchaseNetCardFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const PurchaseNetCardList = (props) => {
  const { permissions } = usePermissions();
  const [theme] = useTheme("light");
  const [appliedParentFilter, setAppliedParentFilter] = useState(null);
  const {
    filterDefaultValues,
  } = useCompanyScopedListFilters({
    start_date: firstDate,
    end_date: lastDate,
    approved: 1,
  });

  const list = useMemo(() => {
    return (
      <>
        <ManualReportList
          storeKey={false}
          title={props.title ? props.title : undefined}
          empty={false}
          // aside={
          //   <PurchaseNetCardAsideList
          //     name="TOTAL PEMBELIAN"
          //     filter={{ approved: 1 }}
          //   />
          // }
          actions={<DownloadAction />}
          filters={purchaseNetCardFilterList(permissions)}
          filter={{
            approved: 1,
          }}
          filterDefaultValues={filterDefaultValues}
          requiredFilters={["start_date", "end_date"]}
          onApplied={setAppliedParentFilter}
          onReset={() => setAppliedParentFilter(null)}
          queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
          sx={{
            flexDirection: "column",
          }}
        >
          <DatagridConfigurable
            body={<MyDatagridBody footer={<PurchaseNetCardFooterList />} />}
            bulkActionButtons={false}
            expand={<PurchaseNetCardExpandList />}
            sx={{
              "& .RaDatagrid-expandedPanel > td": {
                p: 0,
                bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
              },
            }}
          >
            <TextField label="mine.label.depo" source="company.alias" />
            <TextField source="code" label="mine.label.receipt_no" />
            <DateField
              source="date"
              label="mine.label.date"
              options={{
                year: "numeric",
                month: "short",
                day: "2-digit",
              }}
            />
            <TextField label="mine.label.supplier" source="supplier.name" />
            <TextField
              label="SJ Pabrik"
              source="delivery_note"
            />
            <FunctionField
              textAlign="right"
              label="Box"
              render={(record) => {
                let rec = { total_received: 0 };
                for (let i = 0; i < record.purchase_items.length; i++) {
                  rec.total_received +=
                    +record.purchase_items[i].received_quantity;
                }
                return (
                  <RecordContextProvider value={rec}>
                    <NumberField source="total_received" />
                  </RecordContextProvider>
                );
              }}
            />
            <NumberField source="total" label="mine.label.value" />
            <TextField source="note" label="mine.label.note" />
          </DatagridConfigurable>
        </ManualReportList>
        <div style={{ margin: "22px 0 8px 0" }} /> {/* ================ */}
        {appliedParentFilter ? <PurchaseReturnCardList
          withActions={false}
          withFilters={false}
          grandTotalResource="purchase-net-cards"
          title=" "
          parentFilter={appliedParentFilter}
        /> : null}
      </>
    );
  }, [
    theme,
    permissions,
    props.title,
    appliedParentFilter,
    filterDefaultValues,
  ]);
  return list;
};

export default PurchaseNetCardList;
